var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "109px",
    viewBox: "0 0 160 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB5CA908-3668-4CBE-9103-F3F215558E41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-suitable-for",
    transform: "translate(-588.000000, -398.000000)",
    strokeWidth: 4.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(591.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.264955,41.729695 C100.264955,54.742695 89.705455,65.291345 76.679155,65.291345 C63.653205,65.291345 53.093705,54.742695 53.093705,41.729695 C53.093705,28.717045 63.653205,18.168045 76.679155,18.168045 C89.705455,18.168045 100.264955,28.717045 100.264955,41.729695 Z",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.458835,105.47103 C36.458835,83.28068 54.465985,65.29138 76.679435,65.29138 C98.892535,65.29138 116.900035,83.28068 116.900035,105.47103",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.63203,47.00192 C41.83893,47.08207 41.03463,47.12372 40.22053,47.12372 C27.19458,47.12372 16.63473,36.57472 16.63473,23.56172 C16.63473,10.54907 27.19458,7e-05 40.22053,7e-05 C48.70768,7e-05 56.14798,4.47867 60.30248,11.19902",
    id: "Stroke-5",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5e-05,87.30316 C3.5e-05,65.11281 18.007185,47.12351 40.220635,47.12351 C41.026335,47.12351 41.826435,47.14731 42.620585,47.19386",
    id: "Stroke-7",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.399855,47.00192 C112.192605,47.08207 112.997255,47.12372 113.811355,47.12372 C126.837305,47.12372 137.396805,36.57472 137.396805,23.56172 C137.396805,10.54907 126.837305,7e-05 113.811355,7e-05 C105.324205,7e-05 97.883905,4.47867 93.729405,11.19902",
    id: "Stroke-9",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.03185,87.30316 C154.03185,65.11281 136.02435,47.12351 113.81125,47.12351 C113.00555,47.12351 112.2051,47.14731 111.4113,47.19386",
    id: "Stroke-11",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.06346,
    y1: 8.631105,
    x2: 109.96811,
    y2: 74.536105,
    id: "Stroke-13",
    stroke: "#EE7330",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.96825,
    y1: 8.631105,
    x2: 44.0636,
    y2: 74.536105,
    id: "Stroke-15",
    stroke: "#EE7330",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCross);
export default __webpack_public_path__ + "static/media/peopleCross.12f503c4.svg";
export { ForwardRef as ReactComponent };